import ajax from '@/resources/myApi';
import vm from '@/main';

export const service = {
  getDocuments,
};

async function getDocuments(id) {

  try {
    const { data } = await ajax.get(`api/companyrequireddocument/forcompany/${id}`, {name: 'company documents'});

    return data;
  } catch (error) {
    if (error.response.status < 500) {
      // company does not exist
      vm.$snotify.error('company not found');
      vm.$router.push({ name: 'company' });
    }
    return {};
  }
}

export default service;